module.exports = __webpack_public_path__ + "static/media/man_02.3ae44041.png";